export const ActionTypes = {
  LOADING: "GET_QUOTES_LOADING",
  ERROR: "GET_QUOTES_ERROR",
  SUCCESS: "GET_QUOTES_SUCCESS"
};
